import { LinearProgress } from '@hyperflake/react-ui-library';
import UpdateProjectInstallationForm from 'modules/project-installation/components/UpdateProjectInstallationForm/UpdateProjectInstallationForm';
import ViewProjectInstallationDetail from 'modules/project-installation/components/ViewProjectInstallationDetail/ViewProjectInstallationDetail';
import useProjectInstallationData from 'modules/project-installation/hooks/useProjectInstallationData';
import { PageHeading, PageTemplate } from 'modules/shared/features/content';
import { useParams } from 'react-router-dom';
import InternalApplicationsList from '../components/InternalApplicationsList/InternalApplicationsList';
import useInternalApplicationListData from '../hooks/useInternalApplicationListData';

const ViewInternalApplicationPage = () => {
    const internalApplicationsList = useInternalApplicationListData();
    return (
        <>
            {internalApplicationsList.loading ? (
                <LinearProgress />
            ) : (
                <PageTemplate>
                    <PageHeading>Internal Applications</PageHeading>

                    <InternalApplicationsList interalApplicationData={internalApplicationsList.data} />
                </PageTemplate>
            )}
        </>
    );
};

export default ViewInternalApplicationPage;
